import { Tooltip } from '@progress/kendo-react-tooltip'
import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import React from 'react'
import * as Flash from '../../../flash';
import * as Constants from '../../constants'
import { IntegrationConfigRenderBase } from './integrationConfigRenderBase'

declare const RASA_SELF_SERVICE_API: string

export class YourMembershipConfigRender extends IntegrationConfigRenderBase {
  protected supportsFilter: boolean = false
  protected showContactsCount = false
  private systemApiKeyName: string = 'systemApiKey'
  private systemClientIdName: string = 'systemAccountName'
  private systemApiPasswordName: string = 'password'
  private selectedFilterName: string = 'selectedFilterName'

  protected initializeCustomProps() {
    if (this.systemApiAttribute && this.systemApiAttribute.api_key) {
      this.props.propertiesChanged({
        [this.systemApiKeyName]: this.systemApiAttribute.api_key,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.api_password) {
      this.props.propertiesChanged({
        [this.systemApiPasswordName]: this.systemApiAttribute.api_password,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.client_id) {
      this.props.propertiesChanged({
        [this.systemClientIdName]: this.systemApiAttribute.client_id,
      })
    }
    if (this.systemApiAttribute && this.systemApiAttribute.filter_name) {
      this.props.propertiesChanged({
        [this.selectedFilterName]: this.systemApiAttribute.filter_name,
      })
    }
  }

  protected isAuthenticateButtonEnabled(): boolean {
    return !this.state.isConnecting && !!this.props.data.systemApiKey
      && !!this.props.data.password  && !!this.props.data.systemAccountName
  }

  protected connect() {
    const url = this.buildPopUpUrl()
    this.setState({
      isConnecting: true,
    })
    AjaxWrapper.ajax(url, HttpMethod.GET, {})
    .then((result) => {
      if (!!result.success) {
        window.location.href = Constants.INTEGRATIONS_CONFIG_URL + '?id=' + result.payload.communitySystemId + '&operation=' + `${result.operation}${Constants.SUCCESS}`
      } else {
        this.setState({
          isConnecting: false,
        })
        const errMsg = result.payload ? result.payload.message : ''
        this.props.context.store.dispatch(Flash.showFlashError(errMsg))
      }
    }).catch((err) => {
      this.setState({
        isConnecting: false,
      })
      let message = ''
      try {
        message = err.response.message
      } catch (e) {
        message = err.message
      }
      this.props.context.store.dispatch(Flash.showFlashError(message))
    })
  }

  protected buildPopUpUrl(): string {
    return `${RASA_SELF_SERVICE_API}/integrations/${this.props.data.systemName.replace(' ', '').toLowerCase()}-api-callback?state=${this.encodedCommunityIdentifier}&api_key=${this.props.data.systemApiKey}&api_password=${this.props.data.password}&client_id=${this.props.data.systemAccountName}&filter_name=${this.props.data.selectedFilterName}`
  }

  protected renderCustomBox() {
    return <div className="api-key-wrapper">
      <div>
        {this.createTextBox('Client ID', this.systemClientIdName)}
      </div>
      <div>
        {this.createTextBox('Api Key', this.systemApiKeyName)}
      </div>
      <div>
        {this.createTextBox('Api Password', this.systemApiPasswordName)}
      </div>
      <div>
        {this.createTextBox('Member Type', this.selectedFilterName)}
      </div>
    </div>
  }

  private createTextBox(displayName: string, fieldName: string, helpText: string = '') {
    return <div>
      <Tooltip openDelay={100} position="top" anchorElement="pointer" className="rasa-grid-tooltip">
        <div className="field-label-credentials">
          <span title={helpText || `Input your ${displayName}`}>
            {displayName} (Required)
          </span>
        </div>
      </Tooltip>
      <div className="input-wrapper">
        {!this.props.data.is_active
        ? <input className={`field-textbox field-textbox-${fieldName} system-api-key`}
            value={(this.props.data[fieldName] || '')}
            onChange={(e) => this.props.propertiesChanged({[fieldName]: e.target.value})}
            placeholder={`Enter your ${displayName}`}
          />
        : <div className={`field-textbox field-textbox-${fieldName} system-api-key`}>
            {(this.props.data[fieldName] || '')}
          </div>
        }
      </div>
    </div>
  }
}
